import {
    array,
    assign,
    enums,
    literal,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import { SPENDING_RULES_REDEEM_REWARD_TYPES } from "../constants";

const SpendingRuleRedeemRewardTypeSchema = enums(
    Object.values(SPENDING_RULES_REDEEM_REWARD_TYPES)
);

//Base redeem schema
const SpendingRuleBaseRedeemSchema = object({
    rewardId: string(),
    rewardCode: string(),
    rewardType: SpendingRuleRedeemRewardTypeSchema,
});

//Base redeem reward schema
const SpendingRuleBaseRedeemRewardSchema = object({
    type: SpendingRuleRedeemRewardTypeSchema,
    id: string(),
    code: string(),
    title: string(),
});

//Discount life time schema
const SpendingRulesDiscountLifeTimeSchema = object({
    startsAt: string(),
    endsAt: nullable(string()),
});

//Amount discount redeem schema
const SpendingRulesAmountDiscountRedeemSchema = assign(
    SpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            SpendingRuleBaseRedeemRewardSchema,
            SpendingRulesDiscountLifeTimeSchema,
            object({
                type: literal(
                    SPENDING_RULES_REDEEM_REWARD_TYPES.amountDiscount
                ),
                amount: number(),
                currencyCode: string(),
            })
        ),
    })
);

//Percentage redeem schema
const SpendingRulesPercentageDiscountRedeemSchema = assign(
    SpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            SpendingRuleBaseRedeemRewardSchema,
            SpendingRulesDiscountLifeTimeSchema,
            object({
                type: literal(
                    SPENDING_RULES_REDEEM_REWARD_TYPES.percentageDiscount
                ),
                percents: number(),
            })
        ),
    })
);

//Gift card redeem schema
const SpendingRuleGiftCardRedeemSchema = assign(
    SpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            SpendingRuleBaseRedeemRewardSchema,
            object({
                type: literal(SPENDING_RULES_REDEEM_REWARD_TYPES.giftCard),
                balance: number(),
                initialValue: number(),
                currencyCode: string(),
                expiresAt: nullable(string()),
            })
        ),
    })
);

//Free shipping redeem schema
const SpendingRuleFreeShippingRedeemSchema = assign(
    SpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            SpendingRuleBaseRedeemRewardSchema,
            SpendingRulesDiscountLifeTimeSchema,
            object({
                type: literal(
                    SPENDING_RULES_REDEEM_REWARD_TYPES.shippingDiscount
                ),
                countryCodes: array(string()),
            })
        ),
    })
);

//Free product redeem schema
const SpendingRuleFreeProductRedeemSchema = assign(
    SpendingRuleBaseRedeemSchema,
    object({
        reward: assign(
            SpendingRuleBaseRedeemRewardSchema,
            SpendingRulesDiscountLifeTimeSchema,
            object({
                type: literal(
                    SPENDING_RULES_REDEEM_REWARD_TYPES.productDiscount
                ),
                productId: number(),
                variantId: number(),
                amount: number(),
                percents: number(),
                currencyCode: string(),
            })
        ),
    })
);

export const SpendingRulesRedeemSchema = union([
    SpendingRulesAmountDiscountRedeemSchema,
    SpendingRulesPercentageDiscountRedeemSchema,
    SpendingRuleGiftCardRedeemSchema,
    SpendingRuleFreeShippingRedeemSchema,
    SpendingRuleFreeProductRedeemSchema,
]);
